import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/app'
import "firebase/firestore"
import "firebase/auth"

Vue.use(Vuex)

// Initialize Firebase
const CONFIG = {
    apiKey: "AIzaSyAxZEwAxHhgMZYhoi_UXlEeutNipPq4cQc",
    databaseURL: "https://blind-match-be950.firebaseio.com",
    projectId: "blind-match-be950",
    storageBucket: "blind-match-be950.appspot.com",
    messagingSenderId: "575698420641",
    authDomain: "blind-match-be950.firebaseapp.com",
    }
    firebase.initializeApp(CONFIG);
    firebase.auth().signInAnonymously();
export default new Vuex.Store({
    state: {
        db: firebase.firestore().collection('room'),
        // 登録なし||登録から実行
        id: '',
        uid: '',
    },
    mutations: {
        setId: (state, id)=>state.id = id,
        setUid: (state, id)=>state.uid = id,
    },
})
